// clickable elements like row

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['item']

  connect() {
    this.itemTargets.forEach((item) => {
      item.addEventListener('click', (e) => {
        const url = e.currentTarget.dataset.url
        this.renderTurboStreamFromUrl(url)
      })
    })
  }

  renderTurboStreamFromUrl(url, frame = 'modal', action = 'replace') {
    fetch(url, {
      headers: {
        Accept: "text/vnd.turbo-stream.html"
      }
    })
    .then(r => r.text())
    .then(html => {
      html = `<turbo-stream action="${action}" target="${frame}"><template>${html}</template></turbo-stream>`
      //console.log('html', html)
      Turbo.renderStreamMessage(html)
    })
  }
}
